<template>
  <Container>
    <div class="fee-tool">
      <div class="fee-toolbar">
        <div style="font-size:13px;color:var(--subtext2)">
          项目管理及监理费用测算（2018）· 标准收费本地测算
        </div>
        <Button icon="md-refresh" @click="reset">重置示例</Button>
      </div>

      <div class="fee-card">
        <div class="fee-card-title">一、工程概况</div>
        <div class="fee-form-row">
          <div class="fee-field">
            <label>工程总投资（万元）</label>
            <InputNumber v-model="project.totalInvest" :min="0" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>土地费用（万元）</label>
            <InputNumber v-model="project.landCost" :min="0" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>建安造价（万元）</label>
            <InputNumber v-model="project.construction" :min="0" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>建筑总面积（平方米）</label>
            <InputNumber v-model="project.area" :min="0" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>监理专业调整系数</label>
            <InputNumber v-model="project.specialtyFactor" :min="0" :step="0.1" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>工程复杂程度系数</label>
            <InputNumber v-model="project.complexityFactor" :min="0" :step="0.1" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
          <div class="fee-field">
            <label>高程调整系数</label>
            <InputNumber v-model="project.elevationFactor" :min="0" :step="0.1" :active-change="false" style="width:100%" @on-change="calc" />
          </div>
        </div>
        <div class="fee-hint" v-if="result">
          计费基数（总投资－土地）={{ fmt(result.project.investMinusLand) }} 万元；
          监理调整综合系数={{ fmt(result.project.factor) }}
        </div>
      </div>

      <div class="fee-card fee-item-table">
        <div class="fee-card-title">二、费用项目</div>
        <Table :columns="columns" :data="tableRows" border size="small" />
        <div class="fee-hint" style="margin-top:8px">下浮率按小数填写，如下浮 8% 填 0.08。施工监理费按收费点插值，并乘专业/复杂/高程系数。</div>
      </div>

      <div class="fee-card" v-if="result">
        <div class="fee-card-title">三、汇总</div>
        <div class="fee-summary">
          <div class="fee-sum-item">
            <span class="label">标准收费合计</span>
            <span class="value">{{ fmt(result.sumStandard) }} 万元</span>
          </div>
          <div class="fee-sum-item highlight">
            <span class="label">下浮后合计</span>
            <span class="value">{{ fmt(result.sumAfter) }} 万元</span>
          </div>
          <div class="fee-sum-item">
            <span class="label">下浮后单方造价</span>
            <span class="value">{{ fmt(result.sumUnit) }} 元/㎡</span>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import {PM_FEE_DEFS, calcPmSupervision} from './fee-calc';

const DEFAULT_ENABLED = {
  cm_2018: true,
  agency_new: true,
  cost_control: true,
  control_price_only: false,
  settlement_audit: true,
  invest_estimate_audit: false,
  final_finance: false,
  invest_budget_audit: true,
  supervision_2018: true,
  supervision_old: false,
};

export default {
  components: {Container},
  data() {
    return {
      project: {
        totalInvest: 980,
        landCost: 0,
        construction: 980,
        area: 110000,
        specialtyFactor: 1,
        complexityFactor: 1,
        elevationFactor: 1,
      },
      options: {},
      result: null,
      columns: [
        {
          title: '启用',
          key: 'enabled',
          width: 60,
          align: 'center',
          render: (h, {row}) =>
            h('Checkbox', {
              props: {value: row.enabled},
              on: {
                'on-change': (v) => {
                  this.$set(this.options[row.key], 'enabled', v);
                  this.calc();
                },
              },
            }),
        },
        {title: '费用项目', key: 'name', minWidth: 180},
        {title: '计费说明', key: 'baseLabel', minWidth: 160},
        {
          title: '计费基数(万元)',
          key: 'base',
          width: 120,
          align: 'right',
          render: (h, {row}) => h('span', this.fmt(row.base)),
        },
        {
          title: '下浮率',
          key: 'discount',
          width: 110,
          render: (h, {row}) =>
            h('InputNumber', {
              props: {
                value: row.discount,
                min: 0,
                max: 1,
                step: 0.01,
                activeChange: false,
                size: 'small',
                disabled: !row.enabled,
              },
              style: {width: '100%'},
              on: {
                'on-change': (v) => {
                  this.$set(this.options[row.key], 'discount', v);
                  this.calc();
                },
              },
            }),
        },
        {
          title: '标准收费(万元)',
          key: 'standard',
          width: 130,
          align: 'right',
          render: (h, {row}) => h('span', this.fmt(row.standard)),
        },
        {
          title: '下浮后(万元)',
          key: 'afterDiscount',
          width: 120,
          align: 'right',
          render: (h, {row}) =>
            h('span', {style: {fontWeight: 600, color: '#2d8cf0'}}, this.fmt(row.afterDiscount)),
        },
        {
          title: '单方(元/㎡)',
          key: 'unitPrice',
          width: 110,
          align: 'right',
          render: (h, {row}) => h('span', this.fmt(row.unitPrice)),
        },
      ],
    };
  },
  computed: {
    tableRows() {
      return (this.result && this.result.items) || [];
    },
  },
  created() {
    this.initOptions();
    this.calc();
  },
  methods: {
    initOptions() {
      const opts = {};
      PM_FEE_DEFS.forEach((d) => {
        opts[d.key] = {
          enabled: DEFAULT_ENABLED[d.key] !== false,
          discount: d.defaultDiscount || 0,
        };
      });
      // 示例：建设管理费常按 0.3 下浮出现在另一 sheet；本页默认 0，用户可改
      this.options = opts;
    },
    reset() {
      this.project = {
        totalInvest: 980,
        landCost: 0,
        construction: 980,
        area: 110000,
        specialtyFactor: 1,
        complexityFactor: 1,
        elevationFactor: 1,
      };
      this.initOptions();
      this.calc();
    },
    calc() {
      this.result = calcPmSupervision(this.project, this.options);
    },
    fmt(v) {
      const n = Number(v) || 0;
      return n.toLocaleString('zh-CN', {maximumFractionDigits: 6});
    },
  },
};
</script>

<style lang="less" scoped>
@import './fee-tool.less';
</style>
